import React from 'react';
import PropTypes from 'prop-types';

import SplitText from '../SplitText';

const Video = ({ content }) => {
  return <SplitText>{content.text || ''}</SplitText>;
};

Video.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string
  }).isRequired
};

export default Video;
